import { IResetSlice } from '@/types'
import {
  createAppSlice,
  createHomeSlice,
  createUserSlice,
  createEditSlice,
  createSearchSlice,
  createNotificationSlice,
  createPresenceSlice,
} from '../slices'

export const resetAllSlices = (set: any): IResetSlice => ({
  resetAll: () => {
    createAppSlice(set).reset()
    createHomeSlice(set).reset()
    createUserSlice(set).reset()
    createEditSlice(set).reset()
    createSearchSlice(set).reset()
    createNotificationSlice(set).reset()
    createPresenceSlice(set).reset()
  },
})
